export default __webpack_public_path__ + "static/media/phone-close.0ae5a2f4.svg";